// extracted by mini-css-extract-plugin
export default {"typeContainer":"Type_typeContainer__26eGl","checkBoxItem":"Type_checkBoxItem__eEUv-","checkBox":"Type_checkBox__P8AYY"};